"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationWithAnonymizedOrder = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const AnonymizedOrderForDriver_1 = require("../models/AnonymizedOrderForDriver");
const AssignationAutomaticEmail_1 = require("../models/AssignationAutomaticEmail");
let AssignationWithAnonymizedOrder = class AssignationWithAnonymizedOrder {
    _id = (0, uuid_1.v4)();
    driverId;
    driverName;
    forCompany = false;
    createdAt = new Date();
    vehicleType;
    vehicleIndex;
    // The Assignation is accepted: if the vehicle is undefined, acceptation note is defined and contrariwise
    vehicleId;
    acceptationNote;
    meetingPosition;
    subsidyIds = [];
    compensationIds = [];
    penaltyIds = [];
    acceptedAt;
    declinedAt;
    cancelledAt;
    reason;
    cancellationInfo;
    payoutId;
    automaticEmails = [];
    price = 0;
    fee = 0;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    paidCash = 0;
    userVehicles;
    order;
    version = 0;
    comboAssignationOfferId;
    get status() {
        if ((0, utils_1.isNotUndefinedOrNull)(this.cancelledAt)) {
            return legacy_enums_1.AssignationStatus.Cancelled;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.declinedAt)) {
            return legacy_enums_1.AssignationStatus.Declined;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.acceptedAt)) {
            return legacy_enums_1.AssignationStatus.Accepted;
        }
        return legacy_enums_1.AssignationStatus.Pending;
    }
};
exports.AssignationWithAnonymizedOrder = AssignationWithAnonymizedOrder;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "driverId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "driverName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], AssignationWithAnonymizedOrder.prototype, "forCompany", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AssignationWithAnonymizedOrder.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "vehicleType", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "vehicleIndex", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "acceptationNote", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "meetingPosition", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "subsidyIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "compensationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "penaltyIds", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], AssignationWithAnonymizedOrder.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], AssignationWithAnonymizedOrder.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], AssignationWithAnonymizedOrder.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "reason", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], AssignationWithAnonymizedOrder.prototype, "cancellationInfo", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "payoutId", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => AssignationAutomaticEmail_1.AssignationAutomaticEmail),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "automaticEmails", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "price", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "fee", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "pricingCurrency", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "paidCash", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], AssignationWithAnonymizedOrder.prototype, "userVehicles", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", AnonymizedOrderForDriver_1.AnonymizedOrderForDriver)
], AssignationWithAnonymizedOrder.prototype, "order", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationWithAnonymizedOrder.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], AssignationWithAnonymizedOrder.prototype, "comboAssignationOfferId", void 0);
exports.AssignationWithAnonymizedOrder = AssignationWithAnonymizedOrder = __decorate([
    (0, class_transformer_1.Exclude)()
], AssignationWithAnonymizedOrder);
//# sourceMappingURL=AssignationWithAnonymizedOrder.js.map